import { queryClient } from '@/utils'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const useApplyGiftCard = () => {
  const navigate = useNavigate()
  const user = queryClient.getQueryData(['user'])
  useEffect(() => {
    if (!user) return
    const activeGiftCardCode = (window as any).activeGiftCardCode
    if (activeGiftCardCode) {
      ;(window as any).activeGiftCardCode = ''
      navigate('/dashboard/gift-card/claim', {
        state: { giftCardCode: activeGiftCardCode },
      })
    }
  }, [user])
}
